import { useEffect, useState } from 'react';
import type { Vendor } from '@shopgnd/shared';
import { listVendorsStrict } from '@/api/catalog';
import { subscribeCatalogRefresh } from '@/lib/catalog-refresh';

export function useVendors(): { vendors: Vendor[]; ready: boolean; error: string | null } {
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      void listVendorsStrict()
        .then((list) => {
          if (cancelled) return;
          setVendors(list);
          setError(null);
        })
        .catch((e) => {
          if (cancelled) return;
          setVendors([]);
          setError(e instanceof Error ? e.message : 'Could not load vendors.');
        })
        .finally(() => {
          if (!cancelled) setReady(true);
        });
    };
    load();
    const unsub = subscribeCatalogRefresh(load);
    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return { vendors, ready, error };
}
